import { render, staticRenderFns } from "./FactoryVersion.vue?vue&type=template&id=26bb7a9b&scoped=true&"
import script from "./FactoryVersion.vue?vue&type=script&lang=js&"
export * from "./FactoryVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bb7a9b",
  null
  
)

export default component.exports